import axios from "axios";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { ExportIcon } from "../../icons";
import { Link, useHistory } from "react-router-dom";
import { API_URL } from "../../constants/Globals";
import useDebounce from "../../hooks/useDebounce";
import { Dropdown } from "react-bootstrap";

function NewSegment({ selNetworkId, match }) {
  const [tags, setTags] = useState([]);
  const [andOr, setAndOr] = useState("and");
  const [loading, setLoading] = useState(false);
  const [conditions, setConditions] = useState([]);
  const [segmentName, setSegmentName] = useState("");
  const { params } = match;
  const history = useHistory();
  const [searchQueries, setSearchQueries] = useState({});
  const debouncedSearchQueries = useDebounce(searchQueries, 400);

  useEffect(() => {
    Object.keys(debouncedSearchQueries).forEach((index) => {
      const query = debouncedSearchQueries[index];
      if (!query || query.trim().length < 2) {
        setConditions((prev) => {
          const updated = [...prev];
          updated[index].searchResults = [];
          return updated;
        });
        return;
      }

      axios
        .get(
          `${API_URL}/admin/tags?clientId=${selNetworkId}&search=${query.trim()}`
        )
        .then(({ data }) => {
          setConditions((prev) => {
            const updated = [...prev];
            updated[index].searchResults = data.data || [];
            return updated;
          });
        })
        .catch(console.error);
    });
  }, [debouncedSearchQueries, selNetworkId]);

  useEffect(() => {
    if (selNetworkId) {
      axios
        .get(`${API_URL}/admin/tags?clientId=${selNetworkId}`)
        .then(({ data }) => setTags(data.data));

      if (params.id && params.id !== "new") {
        axios
          .get(`${API_URL}/admin/segments?clientId=${selNetworkId}`)
          .then(({ data }) => {
            const editedSegment = data.data.find(
              (segment) => segment.id === parseInt(params.id)
            );

            if (editedSegment) {
              setSegmentName(editedSegment.name);

              const newConditions = [];

              for (let key in editedSegment.conditions) {
                const condition = editedSegment.conditions[key];

                if (key === "andOr" && condition !== "and") {
                  setAndOr("or");
                } else if (key === "dateAdded") {
                  const newCondition = {
                    type: "date",
                    comparator: condition[0] === "lt" ? "before" : "after",
                    selectedDate: condition[1],
                    selectedTag: 0,
                    amountComparator: "any",
                    tagsCount: 2,
                    votesCount: 10,
                  };

                  newConditions.push(newCondition);
                } else if (key === "votes") {
                  const newCondition = {
                    type: "votes",
                    comparator: condition[0] === "lt" ? "smaller" : "greater",
                    selectedDate: "",
                    selectedTag: 0,
                    amountComparator: "any",
                    tagsCount: 2,
                    votesCount: condition[1],
                  };

                  newConditions.push(newCondition);
                } else if (key === "tags") {
                  condition.forEach((tagCondition) => {
                    const newCondition = {
                      type: "tags",
                      comparator:
                        tagCondition.is === "y" ? "tagged" : "untagged",
                      selectedDate: "",
                      selectedTag: tagCondition.id,
                      amountComparator:
                        tagCondition.compare === "gt"
                          ? "greater"
                          : tagCondition.compare === "lt"
                            ? "less"
                            : tagCondition.compare,
                      tagsCount: tagCondition.count,
                      votesCount: 10,
                    };

                    newConditions.push(newCondition);
                  });
                }
              }

              setConditions(newConditions);
            }
          });
      }
    }
  }, [selNetworkId, params.id]);

  return (
    <section>
      <h1 className="page-title uppercase">Audience</h1>

      <div className="table-filters">
        <Link to="/audience/segments" className="text-button">
          <svg
            width="9"
            height="14"
            viewBox="0 0 9 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.56 11.8135L6.68 13.6668L0 7.00016L6.68 0.333496L8.56 2.18683L3.81333 7.00016L8.56 11.8135Z"
              fill="#2F80ED"
            />
          </svg>
          Back to All Segments
        </Link>
      </div>

      <div className="segment-form">
        <header>
          <div className="blue-button">Create a segment</div>
          <button className="blue-button">
            <ExportIcon />
            Export Audience
          </button>
          <Link to="/audience/segments" className="blue-button">
            Cancel
          </Link>
        </header>

        <div className="segment-form-body">
          <div className="segment-form-field">
            <label>Name</label>
            <input
              type="text"
              value={segmentName}
              onChange={({ target }) => setSegmentName(target.value)}
            />
          </div>
          <div className="segment-form-info">
            <div>
              <label>Contacts match</label>
              <select
                className="select-box"
                value={andOr}
                onChange={({ target }) => setAndOr(target.value)}
              >
                <option value="and">All</option>
                <option value="or">Any</option>
              </select>
              <label>of the following conditions:</label>
            </div>
            <div>Users in this Segment: 0</div>
          </div>

          {conditions.map((condition, index) => (
            <div className="segment-form-condition" key={index}>
              <div className="segment-form-match">{andOr.toUpperCase()}</div>

              <div className="d-flex flex-wrap align-items-center">
                <select
                  className="select-box"
                  value={condition.type}
                  onChange={({ target }) => {
                    const currentConditions = [].concat(conditions);
                    const { value } = target;
                    currentConditions[index].type = value;
                    currentConditions[index].comparator =
                      value === "votes"
                        ? "greater"
                        : value === "tags"
                          ? "tagged"
                          : "before";
                    setConditions(currentConditions);
                  }}
                >
                  <option value="date">Date added</option>
                  <option value="tags">Tags</option>
                  <option value="votes">Vote count</option>
                </select>

                <select
                  className="select-box"
                  value={condition.comparator}
                  onChange={({ target }) => {
                    const currentConditions = [].concat(conditions);
                    currentConditions[index].comparator = target.value;
                    setConditions(currentConditions);
                  }}
                >
                  {condition.type === "date" ? (
                    <option value="before">is before</option>
                  ) : null}
                  {condition.type === "date" ? (
                    <option value="after">is after</option>
                  ) : null}
                  {condition.type === "tags" ? (
                    <option value="tagged">contact is tagged</option>
                  ) : null}
                  {condition.type === "tags" ? (
                    <option value="untagged">contact is not tagged</option>
                  ) : null}
                  {condition.type === "votes" ? (
                    <option value="greater">greater than</option>
                  ) : null}
                  {condition.type === "votes" ? (
                    <option value="smaller">less than</option>
                  ) : null}
                </select>

                {condition.type === "date" ? (
                  <input
                    className="input-box"
                    type="date"
                    value={
                      condition.selectedDate
                        ? condition.selectedDate
                        : "dd-mm-yyyy"
                    }
                    onChange={({ target }) => {
                      const currentConditions = [].concat(conditions);
                      currentConditions[index].selectedDate = target.value;
                      setConditions(currentConditions);
                    }}
                  />
                ) : null}

                {condition.type === "tags" ? (
                  <>
                    <div style={{ position: "relative" }}>
                      <input
                        className="input-box"
                        type="text"
                        placeholder="Search for a tag"
                        value={condition.searchQuery}
                        onChange={(e) => {
                          const query = e.target.value;
                          const updatedConditions = [...conditions];
                          updatedConditions[index].searchQuery = query;
                          updatedConditions[index].showDropdown = true;
                          setConditions(updatedConditions);
                          setSearchQueries((prev) => ({
                            ...prev,
                            [index]: query,
                          }));
                        }}
                        disabled={loading}
                      />

                      <div className="standard-dropdown">
                        {condition.showDropdown && condition.searchQuery && (
                          <Dropdown.Menu
                            show
                            style={{
                              width: "100%",
                              maxHeight: "250px",
                              overflowY: "auto",
                              position: "absolute",
                              zIndex: 10,
                            }}
                          >
                            {condition.searchQuery.trim().length < 2 ? (
                              <Dropdown.Item disabled>
                                Type at least 2 characters...
                              </Dropdown.Item>
                            ) : condition.searchResults.length > 0 ? (
                              condition.searchResults.map((tag) => (
                                <Dropdown.Item
                                  key={`tag-${tag.id}`}
                                  onClick={() => {
                                    const updatedConditions = [...conditions];
                                    updatedConditions[index].selectedTag =
                                      tag.id;
                                    updatedConditions[index].searchQuery =
                                      tag.text;
                                    updatedConditions[index].showDropdown =
                                      false;
                                    setConditions(updatedConditions);
                                  }}
                                >
                                  {tag.text}
                                </Dropdown.Item>
                              ))
                            ) : (
                              <Dropdown.Item disabled>
                                No tags found
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        )}
                      </div>
                    </div>

                    {condition.comparator === "tagged" &&
                    condition.selectedTag > 0 ? (
                      <>
                        <select
                          className="select-box"
                          value={condition.amountComparator}
                          onChange={({ target }) => {
                            const currentConditions = [].concat(conditions);
                            currentConditions[index].amountComparator =
                              target.value;
                            setConditions(currentConditions);
                          }}
                        >
                          <option value="any">any amount</option>
                          <option value="greater">greater than</option>
                          <option value="less">less than</option>
                          <option value="equal">equal to</option>
                        </select>
                        {condition.amountComparator === "any" ? null : (
                          <select
                            className="select-box"
                            value={condition.tagsCount}
                            onChange={({ target }) => {
                              const currentConditions = [].concat(conditions);
                              currentConditions[index].tagsCount = target.value;
                              setConditions(currentConditions);
                            }}
                          >
                            <option value="2">2 times</option>
                            <option value="5">5 times</option>
                            <option value="10">10 times</option>
                            <option value="15">15 times</option>
                            <option value="20">20 times</option>
                          </select>
                        )}
                      </>
                    ) : null}
                  </>
                ) : null}

                {condition.type === "votes" ? (
                  <select
                    className="select-box"
                    value={condition.votesCount}
                    onChange={({ target }) => {
                      const currentConditions = [].concat(conditions);
                      currentConditions[index].votesCount = target.value;
                      setConditions(currentConditions);
                    }}
                  >
                    <option>10</option>
                    <option>50</option>
                    <option>100</option>
                    <option>250</option>
                    <option>500</option>
                  </select>
                ) : null}

                {index > 0 ? (
                  <span
                    className="text-button underlined"
                    onClick={() => {
                      const currentConditions = [].concat(conditions);
                      currentConditions.splice(index, 1);
                      setConditions(currentConditions);
                    }}
                  >
                    Remove
                  </span>
                ) : null}
              </div>
            </div>
          ))}

          <div className="segment-form-plus">
            <button
              className="blue-button bordered"
              onClick={() => {
                const currentConditions = [].concat(conditions);
                currentConditions.push({
                  type: "date",
                  comparator: "before",
                  selectedDate: "",
                  selectedTag: 0,
                  amountComparator: "any",
                  tagsCount: 2,
                  votesCount: 10,
                  searchQuery: "",
                  searchResults: [],
                  showDropdown: false,
                });
                setConditions(currentConditions);
              }}
            >
              + Add Condition
            </button>
          </div>

          <div className="segment-form-buttons">
            <button
              className="blue-button"
              onClick={() => {
                setLoading(true);

                const conditionsPayload = {
                  andOr,
                  tags: [],
                };

                conditions.forEach((condition) => {
                  const {
                    type,
                    comparator,
                    selectedDate,
                    votesCount,
                    selectedTag,
                    tagsCount,
                    amountComparator,
                  } = condition;

                  if (type === "date") {
                    conditionsPayload.dateAdded = [
                      comparator === "before" ? "lt" : "gt",
                      selectedDate,
                    ];
                  } else if (type === "votes") {
                    conditionsPayload.votes = [
                      comparator === "smaller" ? "lt" : "gt",
                      votesCount,
                    ];
                  } else {
                    conditionsPayload.tags.push({
                      id: selectedTag,
                      is: comparator === "tagged" ? "y" : "n",
                      count: tagsCount,
                      compare:
                        amountComparator === "greater"
                          ? "gt"
                          : amountComparator === "less"
                            ? "lt"
                            : amountComparator,
                    });
                  }
                });

                axios
                  .post(
                    `${API_URL}/admin/segments/upsert${params.id && params.id !== "new" ? `/${params.id}` : ""}?clientId=${selNetworkId}`,
                    {
                      name: segmentName,
                      conditions: conditionsPayload,
                    }
                  )
                  .then(({ data }) => {
                    setLoading(false);
                    alert(data.message);
                    history.push("/audience/segments");
                  })
                  .catch(({ response }) => {
                    const { data } = response;
                    const { message } = data;
                    const error = message[0];

                    setLoading(false);
                    alert(error[Object.keys(error)[0]]);
                  });
              }}
              disabled={loading}
            >
              Save Segment
            </button>
            <Link to="/audience/segments" className="text-button underlined">
              Cancel
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = (state) => ({
  selNetworkId: state.networks.selNetworkId,
});

export default connect(mapStateToProps)(NewSegment);
